var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGauge3(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 207,
    height: 144,
    viewBox: "0 0 207 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.5839 21.617C68.1528 22.0801 67.3681 23.6157 67.8312 25.0468C68.2943 26.4779 69.8298 27.2626 71.2609 26.7995C91.4293 20.273 113.152 20.3386 133.281 26.9869C134.709 27.4587 136.249 26.6832 136.721 25.255C137.193 23.8267 136.417 22.2864 134.989 21.8147C113.762 14.8035 90.8532 14.7343 69.5839 21.617ZM139.556 26.1572C140.162 24.7804 141.769 24.155 143.146 24.7606C163.609 33.7601 180.676 49.0425 191.871 68.3927C192.624 69.6946 192.179 71.3607 190.877 72.114C189.575 72.8672 187.909 72.4224 187.156 71.1205C176.54 52.7719 160.357 38.2805 140.953 29.7468C139.576 29.1412 138.951 27.5341 139.556 26.1572ZM192.193 74.4345C193.556 73.7964 195.177 74.3833 195.815 75.7454C205.299 95.9894 208.089 118.727 203.783 140.664C203.493 142.14 202.061 143.101 200.585 142.812C199.109 142.522 198.148 141.09 198.437 139.614C202.521 118.813 199.875 97.2523 190.882 78.0562C190.244 76.6941 190.831 75.0726 192.193 74.4345ZM13.344 71.5445C12.0507 70.7764 11.6249 69.1054 12.3929 67.8121C23.8078 48.5908 41.0471 33.5039 61.6121 24.7382C62.9958 24.1484 64.5956 24.792 65.1854 26.1757C65.7752 27.5594 65.1316 29.1592 63.7479 29.749C44.2474 38.061 27.9004 52.367 17.0764 70.5934C16.3083 71.8867 14.6373 72.3125 13.344 71.5445ZM3.18323 140.634C3.53092 142.098 4.99912 143.002 6.46255 142.654C7.92598 142.307 8.83046 140.839 8.48277 139.375C3.58277 118.751 5.37776 97.1024 13.6076 77.5671C14.1915 76.1809 13.5412 74.5838 12.155 73.9998C10.7688 73.4158 9.17172 74.0661 8.58776 75.4523C-0.0912705 96.0541 -1.98424 118.884 3.18323 140.634Z",
    fill: "url(#paint0_radial_127_90122)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_127_90122)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 103.165,
    cy: 18.2367,
    r: 8.20104,
    transform: "rotate(0.25 103.165 18.2367)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 103.165,
    cy: 18.2367,
    r: 8.20104,
    transform: "rotate(0.25 103.165 18.2367)",
    stroke: "#FECC3A",
    strokeWidth: 5.44706
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_127_90122",
    x: 75.1547,
    y: 0.478059,
    width: 56.0206,
    height: 56.0199,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.4171
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.4171
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.207843 0 0 0 0 0.247059 0 0 0 0 0.270588 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_127_90122"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10.2513
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.54275
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.207843 0 0 0 0 0.247059 0 0 0 0 0.270588 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_127_90122",
    result: "effect2_dropShadow_127_90122"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_127_90122",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_127_90122",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.06315 143.466) scale(194.927 243.276)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBDBFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.570451,
    stopColor: "#92C6FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.570551,
    stopColor: "#FECC3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#D8863D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7291B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGauge3);
export default __webpack_public_path__ + "assets/media/gauge-3.a52e282b.svg";
export { ForwardRef as ReactComponent };